document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-vhues-add-bag]');
  if (!btn) return;

  const wrap = btn.closest('[data-vhues-bag-offer]');
  const select = wrap?.querySelector('[data-vhues-bag-variant]');
  const variantId = select?.value;
  if (!variantId) return;

  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';

  try {
    // 1) Add bag
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
    if (!addRes.ok) throw new Error('Add failed');

    // 2) Pull fresh cart data
    const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!cartRes.ok) throw new Error('Cart fetch failed');
    const cart = await cartRes.json();

    // 3) Update bubble count (your theme uses cart-bubble markup)
    const bubbleCount = document.querySelector('.cart-bubble__text-count');
    const bubbleWrap = document.querySelector('.cart-bubble');
    if (bubbleCount) bubbleCount.textContent = String(cart.item_count);
    if (bubbleWrap) {
      bubbleWrap.classList.toggle('visually-hidden', cart.item_count === 0);
    }

    // 4) Refresh main cart page if present (your section file appears to be main-cart.liquid)
    // This only works if "main-cart" is truly in /sections, which your find strongly suggests.
    const onCartPage = document.querySelector('cart-items-component.cart-items-component');
    if (onCartPage) {
      const secRes = await fetch('/?sections=main-cart', { credentials: 'same-origin' });
      if (secRes.ok) {
        const html = await secRes.json();
        if (html && html['main-cart']) {
          const parsed = new DOMParser().parseFromString(html['main-cart'], 'text/html');
          const fresh = parsed.querySelector('cart-items-component.cart-items-component');
          const current = document.querySelector('cart-items-component.cart-items-component');
          if (fresh && current) current.outerHTML = fresh.outerHTML;
        }
      }
    }

    // 5) Refresh cart drawer *without* pretending it's a section
    // We can re-fetch the current page HTML and extract cart-drawer-component from it.
    // This works because your cart drawer is present in the DOM via snippets.
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      const pageRes = await fetch(window.location.pathname + window.location.search, {
        credentials: 'same-origin'
      });
      if (pageRes.ok) {
        const pageHtml = await pageRes.text();
        const parsed = new DOMParser().parseFromString(pageHtml, 'text/html');
        const freshDrawer = parsed.querySelector('cart-drawer-component');
        if (freshDrawer) drawer.outerHTML = freshDrawer.outerHTML;
      }
    }

    btn.textContent = '✓ Added';
    setTimeout(() => {
      btn.textContent = original;
      btn.disabled = false;
    }, 1200);

  } catch (err) {
    console.error(err);
    btn.textContent = 'Try again';
    setTimeout(() => {
      btn.textContent = original;
      btn.disabled = false;
    }, 1400);
  }
});